import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { logout, getUser } from '../storage';
import { requestNotificationPermission } from '../push';

type PushState = 'idle' | 'asking' | 'granted' | 'denied' | 'error';

export default function Settings() {
  const navigate = useNavigate();
  const user = getUser();
  const [pushState, setPushState] = useState<PushState>(
    typeof Notification !== 'undefined' && Notification.permission === 'granted' ? 'granted' : 'idle'
  );
  const [pushMsg, setPushMsg] = useState<string>('');

  async function doLogout() {
    logout();
    navigate('/login', { replace: true });
  }

  async function enablePush() {
    setPushState('asking');
    setPushMsg('');
    try {
      const ok = await requestNotificationPermission();
      if (ok) {
        setPushState('granted');
        setPushMsg('已开启浏览器通知');
      } else {
        setPushState('denied');
        setPushMsg('未授权(浏览器默认或关闭了请求)');
      }
    } catch (e: any) {
      setPushState('error');
      setPushMsg(e?.message || String(e));
    }
  }

  const btnLabel =
    pushState === 'asking' ? '开启中…' :
    pushState === 'granted' ? '✓ 通知已开启' :
    pushState === 'denied' ? '未开启(点此重试)' :
    pushState === 'error' ? '开启失败(点此重试)' :
    '开启浏览器通知';

  return (
    <div className="page settings">
      <h1>设置</h1>
      {user && <p className="user-email">已登录: {user.email}</p>}
      <button type="button" onClick={enablePush} disabled={pushState === 'asking'}>
        {btnLabel}
      </button>
      {pushMsg && (
        <p style={{ color: pushState === 'error' ? '#dc2626' : pushState === 'granted' ? '#16a34a' : '#6b7280', fontSize: 14 }}>
          {pushMsg}
        </p>
      )}
      <button type="button" onClick={doLogout}>退出登录</button>
      <p>
        <Link to="/">返回看板</Link>
      </p>
    </div>
  );
}
